export enum BulkAddExitReason {
    Save = "Save",
    Cancel = "Cancel",
    Edit = "Edit"
}
